<!-- Trigger button -->
@if (showButton) {
<div class="w-100">
  <i-tabler class="open_filter_button" (click)="showHideFilters()"
    [name]="showFilters ? 'adjustments-off' : 'adjustments-alt'" matTooltip="Filtri" />
</div>
}

<!-- Mostra filtri -->
@if (showFilters && formReady && !showButton) {
<mat-card class="m-t-20">
  <mat-card-header>
    <mat-card-title>Filtri</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="formFilter" (ngSubmit)="onSubmit()">
      <!-- Layout a righe -->
      @if (isLayoutFormat()) {
      <div *ngFor="let row of filtersList as FilterLayout" class="row filters-row p-x-10" [ngClass]="{
              'justify-content-center': row.style?.align === 'center',
            }">
        @for (filter of row.filters; track filter) {
        <ng-container [ngTemplateOutlet]="filterTemplate" [ngTemplateOutletContext]="{ filter: filter }"></ng-container>
        }
      </div>
      }
      <!-- Template per i filtri -->
      <ng-template #filterTemplate let-filter="filter">
        @switch (filter.filterName) {
        <!-- Impianti -->
        @case (filtersType.plant) {
        <div class="col-sm-12 col-md-12 col-lg-2 p-x-0" [ngClass]="getColSize(filter.colSize)">
          <mat-form-field appearance="outline">
            <mat-label>Impianto</mat-label>
            <mat-select formControlName="plant">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Cerca impianto" [formControl]="ngxPlantSearchCtrl"
                  noEntriesFoundLabel="" />
              </mat-option>
              <mat-option value="">Tutti</mat-option>
              @for (plant of plantsParsedList; track plant) {
              <mat-option [value]="plant.id">
                {{ plant.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
        <!-- CAMPAGNE LISTA -->
        @case (filtersType.campaigns) {
        <div class="col-sm-12 p-x-0" [ngClass]="getColSize(filter.colSize)">
          <mat-form-field appearance="outline">
          <mat-label>Campagna MOCK</mat-label>
            <mat-select formControlName="campaigns">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Cerca campagna" [formControl]="ngxCampaignSearchCtrl"
                  noEntriesFoundLabel="" />
              </mat-option>
              <mat-option>Tutte</mat-option>
              @for (campaign of campaignsParsedList; track campaign) {
              <mat-option [value]="campaign.id">
                {{ campaign.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
        <!-- STANDARD DATE RANGE -->
        @case (filtersType.date_range) {
        <div class="col-sm-12 col-md-12 col-lg-4 p-x-0" [ngClass]="getColSize(filter.colSize)"
          [formGroup]="dateRangeGroupFilterCtrl">
          <div class="date-rage d-flex gap-15">
            <mat-form-field appearance="outline">
              <mat-label>Data da</mat-label>
              <input matInput formControlName="startDate" (dateChange)="onInputStartDateRange($event)"
                placeholder="GG/MM/AAAA" dateInputMask (keydown.enter)="$event.preventDefault()"
                [min]="dateRangeOptions?.minDate" [max]="
                        dateRangeOptions?.maxDate ??
                        (filtersOptions.daterangeWithoutLimits ? null : today)
                      " [matDatepicker]="pickerFrom" #standardStartDateInput />
              <span style="
                        display: flex;
                        align-items: center;
                        padding-right: 4px;
                      " matSuffix>
                @if (getFormGroup("date_range").get("startDate")?.value) {
                <button mat-icon-button (click)="
                            getFormGroup('date_range')
                              .get('startDate')
                              ?.setValue(null)
                          ">
                  <mat-icon>close</mat-icon>
                </button>
                }
                <mat-icon matIconSuffix class="date_range_icon" (click)="pickerFrom.open()"
                  [color]="pickerFrom.opened ? 'primary' : 'default'">date_range</mat-icon>
              </span>
              <mat-datepicker #pickerFrom></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Data a</mat-label>
              <input matInput [min]="dateRangeGroupFilterCtrl.controls.startDate.value" formControlName="endDate"
                placeholder="GG/MM/AAAA" [max]="dateRangeMaxEndDate" [matDatepicker]="pickerTo" dateInputMask
                (keydown.enter)="$event.preventDefault()" />
              <span style="
                        display: flex;
                        align-items: center;
                        padding-right: 4px;
                      " matSuffix>
                @if (getFormGroup("date_range").get("endDate")?.value) {
                <button mat-icon-button (click)="
                            getFormGroup('date_range')
                              .get('endDate')
                              ?.setValue(null)
                          ">
                  <mat-icon>close</mat-icon>
                </button>
                }
                <mat-icon matIconSuffix class="date_range_icon" (click)="pickerTo.open()"
                  [color]="pickerTo.opened ? 'primary' : 'default'">date_range</mat-icon>
              </span>
              <!-- @if (dateRangeOptions?.maxSpan) {
              <mat-hint>Periodo massimo: {{ getMaxSpanLabel() }}</mat-hint>
              } -->
              <!-- <mat-error>
                @if (
                getFormGroup("date_range")
                .get("endDate")
                ?.hasError("matDatepickerMax")
                ) {
                @if (dateRangeOptions?.maxSpan) {
                Periodo massimo consentito: {{ getMaxSpanLabel() }}
                } @else {
                La data non può superare il massimo consentito
                }
                }
                @if (
                getFormGroup("date_range")
                .get("endDate")
                ?.hasError("matDatepickerMin")
                ) {
                La data di fine non può essere precedente alla data di
                inizio
                }
              </mat-error> -->
              <mat-datepicker #pickerTo></mat-datepicker>
            </mat-form-field>
          </div>
          <!-- @if (dateRangeOptions?.maxSpan) {
          <mat-hint class="d-block text-center f-s-12 m-t--8">Periodo massimo: {{ getMaxSpanLabel() }}</mat-hint>
          } -->

          @if(
          getFormGroup("date_range").errors || 
          getFormGroup("date_range").get('startDate')?.errors ||
          getFormGroup("date_range").get('endDate')?.errors
          ){
          <mat-error class="text-center f-s-12 m-t--4">
            @if(dateRangeOptions?.maxSpan && dateRangeGroupFilterCtrl.hasError('maxSpanExceeded')){
            Periodo massimo consentito: {{ getMaxSpanLabel() }}
            <br>
            }
          
            @if (
            getFormGroup("date_range")
            .get("endDate")
            ?.hasError("matDatepickerMax")
            ) {
            La data non può superare il massimo consentito
            <br>
            }
          
            @if (
            getFormGroup("date_range")
            .get("endDate")
            ?.hasError("matDatepickerMin")
            ) {
            La data di fine non può essere precedente alla data di inizio
            }
          </mat-error>
          }
        </div>
        }
        <!-- Prodotto -->
        @case (filtersType.product) {
        <div class="col-sm-12 col-md-12 col-lg-2 p-x-0" [ngClass]="getColSize(filter.colSize)">
          <mat-form-field appearance="outline">
            <mat-label>Prodotto</mat-label>
            <mat-select formControlName="product">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Cerca prodotto" [formControl]="ngxProductSearchCtrl"
                  noEntriesFoundLabel="" />
              </mat-option>
              <mat-option value="">Tutti</mat-option>
              @for (product of productsParsedList; track product) {
              <mat-option [value]="product.id">
                {{ product.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
        <!-- Prodotto Multiplo -->
        @case (filtersType.multi_product) {
        <div class="col-sm-12 col-md-12 col-lg-2 p-x-0" [ngClass]="getColSize(filter.colSize)">
          <mat-form-field appearance="outline">
            <mat-label>Prodotti</mat-label>
            <mat-select formControlName="products" multiple>
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Cerca prodotto" [formControl]="ngxProductSearchCtrl"
                  noEntriesFoundLabel="" />
              </mat-option>
              @for (product of productsParsedList; track product) {
              <mat-option [value]="product.id">
                {{ product.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
        <!-- Impianto multiplo -->
        @case (filtersType.multi_plant) {
        <div class="col-sm-12 col-md-12 col-lg-2 p-x-0" [ngClass]="getColSize(filter.colSize)">
          <mat-form-field appearance="outline">
            <mat-label>Impianto</mat-label>
            <mat-select formControlName="plant" multiple>
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Cerca impianto" noEntriesFoundLabel=""
                  [formControl]="ngxPlantSearchCtrl" />
              </mat-option>
              @for (plant of plantsParsedList; track plant) {
              <mat-option [value]="plant.id">
                {{ plant.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
        <!-- Impianto Asso -->
        @case (filtersType.asso_plant) {
        <div class="col-sm-12 col-md-12 col-lg-2 p-x-0" [ngClass]="getColSize(filter.colSize)">
          <mat-form-field appearance="outline">
            <mat-label>Impianto</mat-label>
            <mat-select formControlName="asso_plant">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Cerca impianto" [formControl]="ngxPlantSearchCtrl"
                  noEntriesFoundLabel="" />
              </mat-option>
              <mat-option value="">Tutti</mat-option>
              @for (plant of assoPlantsParsedList; track plant) {
              <mat-option [value]="plant.id">
                {{ plant.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
        <!-- Impianto multiplo -->
        @case (filtersType.asso_multi_plant) {
        <div class="col-sm-12 col-md-12 col-lg-2 p-x-0" [ngClass]="getColSize(filter.colSize)">
          <mat-form-field appearance="outline">
            <mat-label>Impianto</mat-label>
            <mat-select formControlName="asso_plant" multiple>
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Cerca impianto" noEntriesFoundLabel=""
                  [formControl]="ngxAssoPlantSearchCtrl" />
              </mat-option>
              @for (plant of assoPlantsParsedList; track plant) {
              <mat-option [value]="plant.id">
                {{ plant.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
        <!-- Impianto multiplo -->
        @case (filtersType.asso_only_multi_plant) {
        <div class="col-sm-12 col-md-12 col-lg-2 p-x-0" [ngClass]="getColSize(filter.colSize)">
          <mat-form-field appearance="outline">
            <mat-label>Impianto</mat-label>
            <mat-select formControlName="asso_only_plant" multiple>
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Cerca impianto" noEntriesFoundLabel=""
                  [formControl]="ngxAssoOnlyPlantSearchCtrl" />
              </mat-option>
              @for (plant of assoOnlyPlantsParsedList; track plant) {
              <mat-option [value]="plant.id">
                {{ plant.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
        <!-- Servizio -->
        @case (filtersType.service) {
        <div class="col-sm-12 col-md-12 col-lg-2 p-x-0" [ngClass]="getColSize(filter.colSize)">
          <mat-form-field appearance="outline">
            <mat-label>Modalità</mat-label>
            <mat-select formControlName="service">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Cerca modalità" [formControl]="ngxServiceSearchCtrl"
                  noEntriesFoundLabel="" />
              </mat-option>
              <mat-option value="">Tutte</mat-option>
              @for (service of servicesParsedList; track service) {
              <mat-option [value]="service.id">
                {{ service.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
        <!-- Metodo di pagamento -->
        @case (filtersType.payment_method) {
        <div class="col-sm-12 col-md-12 col-lg-2 p-x-0" [ngClass]="getColSize(filter.colSize)">
          <mat-form-field appearance="outline">
            <mat-label>Metodo di pagamento</mat-label>
            <mat-select formControlName="payment_method">
              <mat-option value="">Tutti</mat-option>
              @for (
              paymentMethod of filterData.paymentMethods;
              track paymentMethod
              ) {
              <mat-option [value]="paymentMethod.id">
                {{ paymentMethod.description }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
        <!-- Fornitore (WLFA) -->
        @case (filtersType.wlfa_supplier) {
        <div class="col-sm-12 col-md-12 col-lg-2 p-x-0" [ngClass]="getColSize(filter.colSize)">
          <mat-form-field appearance="outline">
            <mat-label>Fornitore</mat-label>
            <mat-select formControlName="supplier" (selectionChange)="wlfaSupplierSelected($event.value)">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Cerca fornitore" [formControl]="ngxSupplierSearchCtrl"
                  noEntriesFoundLabel="" />
              </mat-option>
              <mat-option value="">Tutti</mat-option>
              @for (supplier of suppliersParsedList; track supplier) {
              <mat-option [value]="supplier.id">
                {{ supplier.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
        <!-- Prodotto WLFA -->
        @case (filtersType.wlfa_product) {
        <div class="col-sm-12 col-md-12 col-lg-2 p-x-0" [ngClass]="getColSize(filter.colSize)">
          <mat-form-field appearance="outline">
            <mat-label>Prodotto</mat-label>
            <mat-select formControlName="wlfa_product">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Cerca prodotto" [formControl]="ngxWlfaProductSearchCtrl"
                  noEntriesFoundLabel="" />
              </mat-option>
              <mat-option value="">Tutti</mat-option>
              @for (product of wlfaProductsParsedList; track product) {
              <mat-option [value]="product.id">
                {{ product.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
        <!-- Impianto WLFA -->
        @case (filtersType.wlfa_plant) {
        <div class="col-sm-12 col-md-12 col-lg-2 p-x-0" [ngClass]="getColSize(filter.colSize)">
          <mat-form-field appearance="outline">
            <mat-label>Impianto</mat-label>
            <mat-select formControlName="wlfa_plant">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Cerca impianto" [formControl]="ngxWlfaPlantSearchCtrl"
                  noEntriesFoundLabel="" />
              </mat-option>
              <mat-option value="">Tutti</mat-option>
              @for (plant of wlfaPlantsParsedList; track plant) {
              <mat-option [value]="plant.id">
                {{ plant.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
        <!-- Terminali WLFA -->
        @case (filtersType.wlfa_terminal) {
        <div class="col-sm-12 col-md-12 col-lg-2 p-x-0" [ngClass]="getColSize(filter.colSize)">
          <mat-form-field appearance="outline">
            <mat-label>Terminale</mat-label>
            <mat-select formControlName="wlfa_terminal">
                            <mat-option>
                <ngx-mat-select-search placeholderLabel="Cerca terminale" [formControl]="ngxWlfaTerminalSearchCtrl"
                  noEntriesFoundLabel="" />
              </mat-option>
              <mat-option value="">Tutti</mat-option>
              @for (
              terminal of filterData.wlfaTerminals;
              track terminal
              ) {
              <mat-option [value]="terminal.externalService">
                {{ terminal.supplierName }}
                {{ terminal.externalService }} ({{
                terminal.plantName
                }})
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
        <!-- Campagna Asso -->
        @case (filtersType.asso_campaign) {
        <div class="col-sm-12 col-md-12 col-lg-2 p-x-0" [ngClass]="getColSize(filter.colSize)">
          <mat-form-field appearance="outline">
            <mat-label>Campagna</mat-label>
            <mat-select formControlName="asso_campaign">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Cerca campagna" [formControl]="ngxAssoCampaignSearchCtrl"
                  noEntriesFoundLabel="" />
              </mat-option>
              <mat-option value="">Tutte</mat-option>
              @for (campaign of assoCampaignsParsedList; track campaign) {
              <mat-option [value]="campaign.id">
                {{ campaign.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
        <!-- Utente Asso -->
        @case (filtersType.asso_user) {
        <div class="col-sm-12 col-md-12 col-lg-2 p-x-0" [ngClass]="getColSize(filter.colSize)">
          <mat-form-field appearance="outline">
            <mat-label>Cliente</mat-label>
            <mat-select formControlName="asso_user" (openedChange)="onAssoSelectOpenedChange($event)">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Cerca cliente" [formControl]="ngxAssoUserSearchCtrl"
                  [clearSearchInput]="false" noEntriesFoundLabel="" />
              </mat-option>
              @if (!assoUsersHasMinChars) {
              <mat-option disabled>Scrivi almeno 3 lettere per cercare</mat-option>
              } @else {
                @if( showUserAllOption ){
                  <mat-option value="">Tutti</mat-option>
                }
              @for (user of assoUsersParsedList; track user.id) {
              <mat-option [value]="user.id">
                {{ getAssoUserDescription(user) }}
              </mat-option>
              }
              @if (assoUsersLoading) {
              <mat-option disabled>Caricamento...</mat-option>
              }
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
        <!-- Targa -->
        @case (filtersType.plate) {
        <div class="col-sm-12 col-md-12 col-lg-2 p-x-0" [ngClass]="getColSize(filter.colSize)">
          <mat-form-field appearance="outline">
            <mat-label>Targa</mat-label>
            <input matInput formControlName="plate" placeholder="Inserisci targa" />
          </mat-form-field>
        </div>
        }
        }
      </ng-template>
      <div class="d-flex flex-wrap justify-content-center gap-8 align-items-center m-b-8 filter_button_wrapper" >
        <div class="col-12 col-md-3 col-lg-2">
          <button (click)="resetFilters()" mat-stroked-button color="warn" type="button" class="w-100">
            Reset filtri
          </button>
        </div>
        <div class="col-12 col-md-3 col-lg-2">
          <button mat-raised-button color="primary" class="w-100">
            Applica filtri
          </button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>
}